"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const office_ui_fabric_react_1 = require("office-ui-fabric-react");
const LogoTitle_1 = __importDefault(require("./shared/LogoTitle"));
const styles_1 = require("./shared/styles");
const hookrouter_1 = require("hookrouter");
const AuthProvider_1 = require("../AuthProvider");
const commandButtonStyle = {
    icon: {
        color: 'white'
    },
    label: {
        color: 'white'
    },
    iconHovered: {
        color: 'white'
    },
    root: {
        height: '48px',
        background: 'transparent',
        transition: 'background 0.4s'
    },
    rootHovered: {
        background: 'rgba(255, 255, 255, 0.15)'
    }
};
const personaButtonStyle = {
    root: {
        width: '48px',
        height: '48px',
        background: 'transparent',
        padding: '0px',
        minWidth: 'none',
        border: 'none',
        transition: 'background 0.4s'
    },
    rootHovered: {
        background: 'rgba(255, 255, 255, 0.15)'
    }
};
const DesktopNav = ({ personaInfo, openHelpPanel, openUserInfoPanel }) => {
    const auth = AuthProvider_1.useAuth();
    return (react_1.default.createElement(office_ui_fabric_react_1.Stack, { horizontal: true, verticalAlign: "center", horizontalAlign: "space-between", styles: styles_1.navBarWrapperStyle },
        react_1.default.createElement(office_ui_fabric_react_1.Stack.Item, null,
            react_1.default.createElement(office_ui_fabric_react_1.Stack, { horizontal: true },
                react_1.default.createElement(LogoTitle_1.default, null))),
        auth.isAuthenticated ?
            react_1.default.createElement(office_ui_fabric_react_1.Stack.Item, null,
                react_1.default.createElement(office_ui_fabric_react_1.Stack, { horizontal: true },
                    react_1.default.createElement(office_ui_fabric_react_1.CommandBarButton, { onClick: () => hookrouter_1.navigate('/import-time-entries'), iconProps: { iconName: 'Sort' }, text: "Import", styles: commandButtonStyle }),
                    react_1.default.createElement(office_ui_fabric_react_1.CommandBarButton, { onClick: () => hookrouter_1.navigate('/logs'), iconProps: { iconName: 'ReportWarning' }, text: "Logs", styles: commandButtonStyle }),
                    react_1.default.createElement(office_ui_fabric_react_1.IconButton, { onClick: () => hookrouter_1.navigate('/settings'), iconProps: { iconName: 'Settings' }, title: "Settings", ariaLabel: "Settings", styles: styles_1.iconButtonStyle }),
                    react_1.default.createElement(office_ui_fabric_react_1.IconButton, { onClick: openHelpPanel, iconProps: { iconName: 'Help' }, title: "Help", ariaLabel: "Help", styles: styles_1.iconButtonStyle }),
                    react_1.default.createElement(office_ui_fabric_react_1.Button, { styles: personaButtonStyle, onClick: openUserInfoPanel },
                        react_1.default.createElement(office_ui_fabric_react_1.Persona, Object.assign({}, personaInfo, { size: 11, hidePersonaDetails: true })))))
            : null));
};
exports.default = DesktopNav;
